import { domScriptInjectAsync, REACT_APP__IS_FOREIGN } from "@smp/utils";
import { useMount } from "react-use";

export const useCookiePolicyInit = () =>
  useMount(() => {
    if (!REACT_APP__IS_FOREIGN) {
      try {
        domScriptInjectAsync(
          process.env.REACT_APP__PUBLIC_URL + "/vendor/cookie-policy.js",
        );
      } catch (e) {
        console.log(e);
      }
    }
  });
